"use client";

import { Container } from "components/organisms/Container/Container";
import { Form } from "components/organisms/Form/Form";
import { useLocale } from "next-intl";
import { FC, useMemo } from "react";
import { getFormFields } from "utils/form";
import { CampaignFormSectionRecord } from "@graphql/types/graphql";
import { FormType } from "consts";

import { Locale } from "consts/locale";
import s from "./CampaignFormSection.module.scss";

interface Props {
  data: CampaignFormSectionRecord;
}

export const CampaignFormSection: FC<Props> = ({
  data: { dates, disablePartnershipEnterprise },
}) => {
  const locale = useLocale() as Locale;

  const formFields = useMemo(
    () =>
      getFormFields({
        formType: FormType.campaign,
        locale,
        dates,
        disablePartnershipEnterprise: disablePartnershipEnterprise ?? false,
      }),
    [locale, dates, disablePartnershipEnterprise],
  );

  if (!formFields) {
    return null;
  }

  return (
    <Container size="s" className={s.Container}>
      <Form className={s.Form} fields={formFields} formType={FormType.campaign} />
    </Container>
  );
};
